class AnzerSiteHeader {
  constructor() {
    this.body = $( 'body' );
    this.header = this.body.find( 'header' );
    this.mainMenu = this.header.find( '#mega-menu-main-menu' );
    this.scrollTopPos = this.body.hasClass( 'admin-bar' ) ? 32 : 0;
    this.mainMenuItems = this.mainMenu.find( '>li' );
  }

  init() {
    this.mainMenu
      .find( '.mega-menu-item-has-children > .mega-menu-link' )
      .filter( ':not([href]),[href="#"]' )
      .closest( '.mega-menu-item-has-children' )
      .addClass( 'dummy-parent' );
    this.mainMenuItems.find( '>a[href="#"]' ).removeAttr( 'href' );
    this.toggleScrolledClass();
    this.expandCurrentMenu();
    this.mainMenu.hover( () => {
      this.setSubmenuTopValues( 0 );
    } );
    $( window ).on( 'scroll', () => {
      this.toggleScrolledClass();
    } );
    this.mainMenu.on( 'scroll', () => {
      this.toggleMobileMenuScrollClass();
    } );
  }

  isMobile() {
    return window.matchMedia( '(max-width: 991.98px)' ).matches;
  }

  toggleScrolledClass() {
    if ( $( window ).scrollTop() > this.scrollTopPos ) {
      this.header.addClass( 'scrolled' );
    } else {
      this.header.removeClass( 'scrolled' );
    }
    this.setSubmenuTopValues( 0 );
  }

  toggleMobileMenuScrollClass() {
    if ( this.mainMenu.scrollTop() > 10 ) {
      this.header.addClass( 'mobile-menu-scrolled' );
    } else {
      this.header.removeClass( 'mobile-menu-scrolled' );
    }
  }

  expandCurrentMenu() {
    if ( this.isMobile() ) {
      this.mainMenuItems.filter( '.mega-current-menu-ancestor' ).find( '>a .mega-indicator' ).trigger( 'click' );
    }
  }

  setSubmenuTopValues( adjustment = 0 ) {
    if ( !this.isMobile() ) {
      let headerHeight = this.header.height() + adjustment;
      if ( $( 'body' ).hasClass( 'admin-bar' ) ) {
        headerHeight += 32;
      }
      this.mainMenuItems.find( '>.mega-sub-menu' ).css( {
        top: headerHeight,
      } );
      this.mainMenuItems.find( '>.mega-sub-menu>.mega-menu-row' ).css( {
        maxHeight: $( window ).height() - headerHeight,
      } );
    } else {
      this.mainMenuItems.find( '>.mega-sub-menu>.mega-menu-row' ).css( {
        maxHeight: 'none',
      } );
    }
  }
}

$( () => {
  const siteHeader = new AnzerSiteHeader();
  siteHeader.init();
} );
